import axios from 'axios'

export default {

    /**
     * Get banners
     * @returns {AxiosPromise<any>}
     */
    get: function () {
        return axios.get('/api/banners')
    },

}


// WEBPACK FOOTER //
// ./resources/assets/js/api/banners.js